const SET_MESSAGE = 'SET_MESSAGE';
const REMOVE_MESSAGE = 'REMOVE_MESSAGE';
// A second part of the header, e.g. the position and alternative being calculated
const SET_NAV_MENU_SUB_TEXT = 'SET_NAV_MENU_SUB_TEXT';
const REMOVE_NAV_MENU_SUB_TEXT = 'REMOVE_NAV_MENU_SUB_TEXT';

export {
  SET_MESSAGE,
  REMOVE_MESSAGE,
  SET_NAV_MENU_SUB_TEXT,
  REMOVE_NAV_MENU_SUB_TEXT,
};
